/* tslint:disable */
/* eslint-disable */
/* @relayHash efbc4f400c65751e4c37ea649f9c8fb3 */

import { ConcreteRequest } from "relay-runtime";
export type verifyEmailHandlerQueryVariables = {
    email?: string | null;
    buyerId?: string | null;
    hasBuyerId: boolean;
};
export type verifyEmailHandlerQueryResponse = {
    readonly viewer: {
        readonly user?: {
            readonly profile: {
                readonly email: string | null;
            } | null;
            readonly authMetadata: {
                readonly emailOnly: boolean | null;
                readonly hasPassword: boolean | null;
            } | null;
        } | null;
        readonly userExistsMetadata: {
            readonly emailOnly: boolean | null;
            readonly hasPassword: boolean | null;
            readonly isGuest: boolean | null;
        } | null;
    };
};
export type verifyEmailHandlerQuery = {
    readonly response: verifyEmailHandlerQueryResponse;
    readonly variables: verifyEmailHandlerQueryVariables;
};



const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "email",
    "type": "String",
    "defaultValue": ""
  },
  {
    "kind": "LocalArgument",
    "name": "buyerId",
    "type": "String",
    "defaultValue": ""
  },
  {
    "kind": "LocalArgument",
    "name": "hasBuyerId",
    "type": "Boolean!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "email",
    "variableName": "email"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "emailOnly",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "hasPassword",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "isGuest",
  "args": null,
  "storageKey": null
},
v5 = [
  {
    "kind": "Variable",
    "name": "userId",
    "variableName": "buyerId"
  }
],
v6 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "profile",
  "storageKey": null,
  "args": null,
  "concreteType": "Profile",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "email",
      "args": null,
      "storageKey": null
    }
  ]
},
v7 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "verifyEmailHandlerQuery",
    "type": "RootQueryType",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "userExistsMetadata",
            "storageKey": null,
            "args": (v1/*: any*/),
            "concreteType": "UserExistsMetadataType",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/)
            ]
          },
          {
            "kind": "Condition",
            "passingValue": true,
            "condition": "hasBuyerId",
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "user",
                "storageKey": null,
                "args": (v5/*: any*/),
                "concreteType": "User",
                "plural": false,
                "selections": [
                  (v6/*: any*/),
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "authMetadata",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "UserExistsMetadataType",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v3/*: any*/)
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "verifyEmailHandlerQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "userExistsMetadata",
            "storageKey": null,
            "args": (v1/*: any*/),
            "concreteType": "UserExistsMetadataType",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v7/*: any*/)
            ]
          },
          (v7/*: any*/),
          {
            "kind": "Condition",
            "passingValue": true,
            "condition": "hasBuyerId",
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "user",
                "storageKey": null,
                "args": (v5/*: any*/),
                "concreteType": "User",
                "plural": false,
                "selections": [
                  (v6/*: any*/),
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "authMetadata",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "UserExistsMetadataType",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v3/*: any*/),
                      (v7/*: any*/)
                    ]
                  },
                  (v7/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "verifyEmailHandlerQuery",
    "id": "ferrum/262.0.0-2020-04-28T16:33:21.478Z/verifyEmailHandlerQuery",
    "text": null,
    "metadata": {}
  }
};
})();
(node as any).hash = '929e148997e32bb6b42f33980d349e38';
export default node;
